import {VImage} from './vet-clinic.model';

/**
 * Główny model artykułu w systemie CMS Dashboardu.
 * Służy do publikacji treści informacyjnych (np. instrukcji operacji w panelu)
 * oraz materiałów edukacyjnych/webinarów kierowanych do konkretnych grup odbiorców.
 */
export class Article {


  public uuid: string;
  public vClientUUID: string;
  public userUUID: string;
  public userName: string;
  public modifiedByUUID: string;
  public created: string;
  public modified: string;
  public deleted: string;


  public title: string;
  public articleAbstract: string;
  public content: string;

  /** Przyjazny adres URL artykułu.*/
  public alias: string;


  public petSpecies: string;
  public animalBreeds: string;
  public animalSex: string;
  /** Minimalny wiek zwierzęcia, aby artykuł je dotyczył.*/
  public minAnimalAge: number;
  /** Maksymalny wiek zwierzęcia, aby artykuł je dotyczył.*/
  public maxAnimalAge: number;
  public petAgeType: 'MONTHS' | 'YEARS';
  public isPetSterilized: boolean;
  public isTargeted: boolean;


  public keyWords: string;
  /** Czy artykuł jest opublikowany? */
  public isPublished: boolean;

  /** Flaga oznaczająca artykuł powitalny. */
  public isWelcomeArticle: boolean;

  public publishedSinceDate: string;
  public publishTime?: string;
  public categoryUUID: string;
  public tagsArray: string;


  public promotedImageUUID: string;
  public mainImageUUID: string;
  public promotedImage: VImage;
  public mainImage: VImage;
  public gallery: VImage[] | ArticlePhotoGalleryImage[];
  public contentImages: VImage[] | ArticlePhotoGalleryImage[];


  public userRegistrationHook: boolean;
  public userSyncHook: boolean;
  public addAnimalHook: boolean;
  public visitSyncHook: boolean;
  public reservationHook: boolean;
  public visitReminderHook: boolean;

  /** Licznik otwarć artykułu. */
  public clickCounter: number;

}

/**
 * Lekki model transferu danych (DTO) dla artykułu.
 */
export class ArticleDescriptor {

  public uuid: string;
  public title: string;
  public tagsArray: string;
  public articleAbstract: string;

}

/**
 * Model reprezentujący powiązanie obrazu z konkretną galerią artykułu
 * oraz z klientem (właścicielem zdjęcia).
 */
export class ArticlePhotoGalleryImage {

  public vClientUUID: string;
  public vImageUUID: string;

  constructor(vClientUUID: string, vImageUUID: string) {
    this.vClientUUID = vClientUUID;
    this.vImageUUID = vImageUUID;
  }

}

